import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InterviewService } from "../../../services/InterviewService";
import { JobRoleDetailService } from "../../../services/JobRoleDetailService";
import { AvailabilityService } from "../../../services/AvailabilityService";
import { usePrecandidateContext } from "../context/Context";
import JobRoleDetails from "../../../components/JobRoleDetailsTree/JobRoleDetails";
import { TechRoleService } from "../../../services/TechRoleService";
import { DropDownMultiCheck } from "../../Interview/AdvanceSearch/DropDownMultiCheck";

export default function InterviewListFilters({
  searchObject,
  setSearchObject
}) {
  const [businessAreas, setBusinessAreas] = useState([]);
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);
  const [skills, setSkills] = useState([]);
  const [managers, setManagers] = useState([]);
  const [availability, setAvailability] = useState([]);
  const { t } = useTranslation();
  const [techAreaId, setTechAreaId] = useState();
  const [techRoleId, setTechRoleId] = useState();
  const { onChangeSearch, availabilityStatus } = usePrecandidateContext();

  useEffect(() => {
    getBusinessAreas();
    getTechAreas();
    InterviewService.GetManagerList().then((data) => {
      setManagers(data);
    });
    AvailabilityService.getAvailabilityStatus().then((data) => {
      setAvailability(data);
    });
  }, []);

  useEffect(() => {
    if (techAreaId) {
      getTechRoles(techAreaId);
    } else {
      TechRoleService.getAllTechRoles().then((data) => setTechRoles(data));
    }
  }, [techAreaId]);

  useEffect(() => {
    if (techRoleId) {
      JobRoleDetailService.getTechSkillsByRole(techRoleId).then((data) => {
        let _skills = [];
        for (let skill of data) {
          _skills.push(skill);
        }
        setSkills(_skills);
      });
    }
  }, [techRoleId]);

  function getBusinessAreas() {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setBusinessAreas(data);
    });
  }

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setTechAreas(data);
    });
  }

  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setTechRoles(data);
    });
  }

  function onChange({ target }) {
    if (target.name === "recommended") {
      setSearchObject({ ...searchObject, [target.name]: target.checked });
    } else if (target.name === "techAreaId") {
      setTechAreaId(target.value);
      setSearchObject({
        ...searchObject,
        [target.name]: target.value,
        techRoleId: null
      });
    } else if (target.name === "techRoleId") {
      setTechRoleId(target.value);
      setSearchObject({
        ...searchObject,
        [target.name]: target.value,
        skills: []
      });
    } else {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value
      });
    }
  }

  function onChangeChekBox({ target }) {
    setSearchObject({
      ...searchObject,
      [target.name]: target.checked
    });
  }
  function onchangeCandidateBusinessAreas(selecteds) {
    setSearchObject({
      ...searchObject,
      businessAreas: selecteds
    });
  }

  return (
    <div className="p-4">
      <div className="form-group mt-2">
        <label className="form-label" htmlFor="nameOrEmail">
          {t("Name, Mail or Phone number")}
        </label>
        <input
          type="text"
          className="form-control"
          id="nameOrEmail"
          placeholder={t("Name, Mail or Phone number")}
          value={searchObject.nameOrEmail}
          onChange={(e) =>
            setSearchObject({ ...searchObject, nameOrEmail: e.target.value })
          }
        />
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Business Area")}</label>

        <DropDownMultiCheck
          dataList={businessAreas}
          selecteds={searchObject.businessAreas || []}
          setSelecteds={onchangeCandidateBusinessAreas}
          label={t("Business Area...")}
          hideSelected={true}
        />
      </div>
      <JobRoleDetails
        onChange={onChange}
        searchObject={searchObject}
        techAreas={techAreas}
        techRoles={techRoles}
      ></JobRoleDetails>
      <div className="form-group mt-2">
        <label className="form-label">{t("Status")}</label>
        <select
          as="select"
          name="availabilityStatusId"
          defaultValue={searchObject.availabilityStatusId}
          value={searchObject.availabilityStatusId || ""}
          onChange={onChangeSearch}
          style={{ width: "200px", height: "40px" }}
          title={t("Selecione um item da lista.")}
        >
          <option value="">{t("All Status")}</option>
          {availabilityStatus.map((item) => (
            <option key={item.id} value={item.id}>
              {t(item.description)}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Managers")}</label>
        <select
          name="managerId"
          className="form-select"
          onChange={onChange}
          value={searchObject.managerId || ""}
          title={t("Selecione um item da lista.")}
        >
          <option value="" selected>
            {t("Select manager...")}
          </option>
          {managers?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.nickname}
            </option>
          ))}
        </select>
      </div>
      <div className="mt-2">
        <input
          checked={searchObject.showUnavailable}
          className="form-check-input"
          type="checkbox"
          id="showUnavailable"
          name="showUnavailable"
          onChange={onChangeChekBox}
          value={searchObject.showUnavailable || ""}
        />
        <label className="form-check-label" style={{ marginLeft: "10px" }}>
          {t("Show Unavailable")}
        </label>
      </div>
      <div className="mt-2">
        <input
          checked={searchObject.showAvailable}
          className="form-check-input"
          type="checkbox"
          id="showAvailable"
          name="showAvailable"
          onChange={onChangeChekBox}
          value={searchObject.showAvailable || ""}
        />
        <label
          className="form-check-label"
          title={t(
            "Show Pre-candidates availables or not Contacted for 30 days"
          )}
          data-bs-toggle="tooltip"
          style={{ marginLeft: "10px" }}
        >
          {t("Show Available")}
        </label>
      </div>
      <div className="mt-2">
        <input
          checked={searchObject.teamOnly}
          className="form-check-input"
          type="checkbox"
          id="teamOnly"
          name="teamOnly"
          onChange={onChangeChekBox}
          value={searchObject.teamOnly || ""}
        />
        <label className="form-check-label" style={{ marginLeft: "10px" }}>
          {t("Team members only")}
        </label>
      </div>
      <div className="mt-2">
        <input
          checked={searchObject.showNotAssigned}
          className="form-check-input"
          type="checkbox"
          id="showNotAssigned"
          name="showNotAssigned"
          onChange={onChangeChekBox}
          value={searchObject.showNotAssigned || ""}
        />
        <label className="form-check-label" style={{ marginLeft: "10px" }}>
          {t("Show not assigned")}
        </label>
      </div>
      <div style={{marginTop:"20px"}}>
        <div className="label-wrapper">
          <label>{t("Notes")}</label>
        </div>
        <textarea
          id="notes"
          name="notes"
          className="form-control"
          rows="3"
          value={searchObject.Notes}
          onChange={onChange}
          maxLength={500}
        />
      </div>
    </div>
  );
}
